// ═══════════════════════════════════════
// CONFIG — Constantes globales
// ═══════════════════════════════════════

export const DRONE_FREQS_HP   = [110, 220, 220];         // La  — notation écossaise
export const DRONE_FREQS_CMIN = [116.54, 233.08, 233.08]; // Sib — notation bretonne
export const ORNAMENT_TOTAL_DURATION = 0.05; // secondes
